import React from 'react';
import { ArrowRightIcon, StarIcon, CheckIcon, ClockIcon, ShoppingCartIcon, BrainIcon } from 'lucide-react';
import { CountdownBadge } from './CountdownBadge';
import { LiveVisitorCounter } from './LiveVisitorCounter';
import { trackAddToCart } from './MetaPixel';
export function HeroSection() {
  const handleBuyClick = () => {
    trackAddToCart();
  };
  return <section className="relative pt-8 sm:pt-12 pb-12 sm:pb-20 lg:pt-20 overflow-hidden" data-id="element-83">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 sm:w-96 sm:h-96 bg-orange-100 rounded-full blur-3xl opacity-50" data-id="element-84"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-48 h-48 sm:w-80 sm:h-80 bg-rose-100 rounded-full blur-3xl opacity-50" data-id="element-85"></div>

      <div className="container mx-auto px-4 relative z-10 max-w-7xl" data-id="element-86">
        <div className="flex flex-col lg:flex-row items-center gap-8 sm:gap-12 lg:gap-20" data-id="element-87">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left w-full" data-id="element-88">
            <div className="flex flex-col items-center lg:items-start gap-3 sm:gap-4 mb-4 sm:mb-6" data-id="element-89">
              <LiveVisitorCounter data-id="element-90" />
              <CountdownBadge data-id="element-91" />
            </div>

            <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-gray-900 leading-tight mb-4 sm:mb-6" data-id="element-92">
              <span className="text-rose-500" data-id="element-93">50 Recetas</span> en <br data-id="element-94" />
              <span className="relative inline-block" data-id="element-95">
                5 Minutos
                <svg className="absolute w-full h-2 sm:h-3 -bottom-1 left-0 text-orange-300 -z-10" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-96">
                  <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="8" fill="none" data-id="element-97" />
                </svg>
              </span>
            </h1>

            <p className="text-base sm:text-xl text-orange-800 font-medium mb-6 px-2" data-id="element-98">
              El Sistema Cocina Sin Estrés™ para mujeres que hacen que el mundo
              funcione
            </p>

            {/* Benefit Bullets */}
            <div className="flex flex-col gap-3 mb-8 max-w-xl mx-auto lg:mx-0 text-left" data-id="element-99">
              <div className="flex items-start gap-3 bg-white/60 p-3 rounded-lg border border-orange-50" data-id="element-100">
                <ClockIcon className="w-5 h-5 text-rose-500 flex-shrink-0 mt-0.5" data-id="element-101" />
                <span className="text-gray-700 font-medium" data-id="element-102">
                  5 minutos de preparación activa (de verdad)
                </span>
              </div>
              <div className="flex items-start gap-3 bg-white/60 p-3 rounded-lg border border-orange-50" data-id="element-103">
                <ShoppingCartIcon className="w-5 h-5 text-rose-500 flex-shrink-0 mt-0.5" data-id="element-104" />
                <span className="text-gray-700 font-medium" data-id="element-105">
                  Ingredientes comunes que ya tenés en casa
                </span>
              </div>
              <div className="flex items-start gap-3 bg-white/60 p-3 rounded-lg border border-orange-50" data-id="element-106">
                <BrainIcon className="w-5 h-5 text-rose-500 flex-shrink-0 mt-0.5" data-id="element-107" />
                <span className="text-gray-700 font-medium" data-id="element-108">
                  Cero carga mental: abrís, elegís, cocinás
                </span>
              </div>
            </div>

            <div className="flex flex-col gap-3 justify-center lg:justify-start mb-6 sm:mb-8 px-2" data-id="element-109">
              <a href="https://pay.hotmart.com/S103786789F?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={handleBuyClick} className="group bg-rose-500 hover:bg-rose-600 text-white text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-4 rounded-full font-bold shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-2 animate-button-pulse w-full sm:w-auto mx-auto lg:mx-0 max-w-md" data-id="element-110">
                <span data-id="element-111">Cocinar sin pensar esta noche</span>
                <ArrowRightIcon className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" data-id="element-112" />
              </a>
              <p className="text-gray-500 text-xs sm:text-sm text-center lg:text-left pl-2" data-id="element-113">
                📱 PDF digital · Descarga inmediata · Acceso desde el celular
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 sm:gap-6 text-xs sm:text-sm text-gray-500 px-2" data-id="element-114">
              <div className="flex items-center gap-1" data-id="element-115">
                <CheckIcon className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-116" />
                <span data-id="element-117">Pago Seguro</span>
              </div>
              <div className="flex items-center gap-1" data-id="element-118">
                <CheckIcon className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-119" />
                <span data-id="element-120">Garantía de Satisfacción</span>
              </div>
            </div>
          </div>

          {/* Image Content */}
          <div className="flex-1 relative w-full max-w-md lg:max-w-none mx-auto mt-8 lg:mt-0" data-id="element-121">
            <div className="relative z-10 transform hover:scale-105 transition-transform duration-500 px-4 sm:px-0" data-id="element-122">
              <img src="https://cdn.magicpatterns.com/uploads/trYqPbcKkLNqKgCzacqf27/best_seller_(1).png" alt="50 Recetas en 5 Minutos Libro" className="w-full max-w-md mx-auto drop-shadow-2xl rounded-lg" data-id="element-123" />

              {/* Floating Badge */}
              <div className="absolute -bottom-4 -right-2 sm:-bottom-6 sm:-right-6 bg-white p-3 sm:p-4 rounded-xl shadow-xl border border-orange-100 hidden sm:block" data-id="element-124">
                <div className="flex items-center gap-2 mb-1" data-id="element-125">
                  <div className="flex text-yellow-400" data-id="element-126">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3 h-3 sm:w-4 sm:h-4 fill-current" data-id="element-127" />)}
                  </div>
                  <span className="font-bold text-gray-800 text-sm" data-id="element-128">4.9/5</span>
                </div>
                <p className="text-xs text-gray-500" data-id="element-129">
                  Basado en +1,200 reseñas
                </p>
              </div>
            </div>

            {/* Decorative blob behind image */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-gradient-to-br from-orange-200 to-rose-200 rounded-full blur-3xl -z-10 opacity-60" data-id="element-130"></div>
          </div>
        </div>
      </div>
    </section>;
}